import { combineReducers } from "redux";
import {
  authorization,
  profile,
  currentRoute,
  notifications,
  app,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
  zones,
  zonesForm,
  ingredients,
  ingredientsForm,
  meals,
  mealsForm,
  menus,
  menusForm,
} from "./Reducers";

import { rejectedSuggestions } from "./rejectedSuggestions";

export default combineReducers({
  menus,
  menusForm,
  meals,
  mealsForm,
  ingredients,
  ingredientsForm,
  zones,
  zonesForm,
  app,
  authorization,
  currentRoute,
  profile,
  notifications,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
  rejectedSuggestions,
});
